import { FC, ReactNode } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverContentProps,
  PopoverProps,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react';
import Divider from 'components/elements/PopoverMenu/Divider';
import Header from 'components/elements/PopoverMenu/Header';
import Item from 'components/elements/PopoverMenu/Item';

const popoverStyle = {
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  _focus: {
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  outline: 'none',
  overflow: 'hidden',
};

type ContentProps = {
  sx?: PopoverContentProps['sx'];
  children: ReactNode;
};

const PortalPopoverContent = ({ sx = {}, children }: ContentProps) => {
  return (
    <Portal>
      <PopoverContent sx={{ ...sx, ...popoverStyle }}>{children}</PopoverContent>
    </Portal>
  );
};

type TSavedMenuProps = {
  isOpen?: boolean;
  onClose?: PopoverProps['onClose'];
  onOpen?: PopoverProps['onOpen'];
  children: ReactNode;
  placement?: PopoverProps['placement'];
  /**
   * Match the popover width to the trigger. Defaults to true (select-style
   * dropdowns). Set false when the trigger is much smaller than the content
   * (e.g. an icon button) so the popover sizes to its own content and
   * positions correctly for side placements instead of overflowing.
   */
  matchWidth?: boolean;
};

const PopoverMenu = ({
  isOpen,
  onClose,
  onOpen,
  placement,
  children,
  matchWidth = true,
}: TSavedMenuProps) => {
  return (
    <Popover
      placement={placement || 'top-start'}
      strategy="fixed"
      preventOverflow
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      isLazy
      matchWidth={matchWidth}
    >
      {children}
    </Popover>
  );
};

PopoverMenu.Trigger = PopoverTrigger as FC<{ children?: ReactNode }>;
PopoverMenu.Content = PortalPopoverContent;
PopoverMenu.Header = Header;
PopoverMenu.Item = Item;
PopoverMenu.Divider = Divider;

export default PopoverMenu;
